import React from "react";
import { useState, useContext, useEffect } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import ButtonComponent from "../../Components/ButtonForm/Button";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm from "../../Components/InputForm/InputForm";
import { useSelector } from "react-redux";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import {
  getLongTermLoanCalcByLoanId,
  getShortTermLoanCalcByLoanId,
  postLoanRequestStatusEMI,
} from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { useNavigate } from "react-router-dom";
import { LoanTypeEnum } from "../../Helpers/Enums/Enum";
import BaseModal from "../../Components/BaseModel/BaseModel";
import { getFormattedCurrencyValueWithSymbol } from "../../Helpers/Common";

const LoanAmountDisbursement = (props: any) => {
  let navigate = useNavigate();
  const context = getContext();
  const [loanEmi, setLoanEmi] = useState<any>(0);
  const [totalInterestPayable, setTotalInterestPayable] = useState<any>(0);
  const [totalPayment, setTotalPayment] = useState<any>(0);
  const [loanType, setLoanType] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isModalOpen, setModalOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [confirmValue, setConfirmValue] = useState("");

  const [TermData, setTermData] = useState({
    LoanAmount: 0,
    AdditionalLoanAmount: 0,
    InterestRate: 0,
    LoanTenure: 0,
    LtlAmount: 0,
    LtlEligibleAmount: 0,
    LtlRoi: 0,
    AltlAmount: 0,
    AltlEligibleAmount: 0,
    AltlRoi: 0,
    AdditionalGiveableLoanAmount: 0,
    GiveableLoanAmount: 0
  });

  const [longLoanEmi, setLongLoanEmi] = useState(0);
  const [longTotalInterestPayable, setLongTotalInterestPayable] = useState(0);
  const [longTotalPayment, setLongTotalPayment] = useState(0);

  const [aLTLLongLoanEmi, setALTLLongLoanEmi] = useState(0);
  const [aLTLLongTotalInterestPayable, setALTLLongTotalInterestPayable] =
    useState(0);
  const [aLTLLongTotalPayment, setALTLLongTotalPayment] = useState(0);
  const [isResetClicked, setIsResetClicked] = useState(false);

  const loanParameters = useSelector<any>(
    (state) => state?.LoanModuleReducer?.loanParameters
  );

  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  useEffect(() => {
    getPersonalDetailsByIdApiCall();
  }, []);

  const getPersonalDetailsByIdApiCall = async () => {
    showLoader();
    let requestParams = loanParameters; // { MemberId: MemberId };
    const res = await APICall(getShortTermLoanCalcByLoanId, requestParams);
    const res1 = await APICall(getLongTermLoanCalcByLoanId, requestParams);
   
    if (res?.Status == ApiStatus.OK && res.Data !== null) {
      setLoanType(res?.Data?.Lrd_LoanType);
      if (res1?.Data?.LongTermResult?.Lrd_LoanType == LoanTypeEnum.LONGTERM) {
        // const res = await APICall(getShortTermLoanCalcByLoanId, requestParams);
        // const res1 = await APICall(getLongTermLoanCalcByLoanId, requestParams);

       

        // 
        // if (res1?.Status == ApiStatus.OK && res1.Data !== null) {
        //   setLoanType(res1?.Data?.LongTermResult?.Lrd_LoanType);
        //   if (res1?.Data?.LongTermResult?.Lrd_LoanType == LoanTypeEnum.LONGTERM) {
        setTermData({
          ...TermData,
          LoanTenure: res1?.Data?.LongTermResult?.LTLDuration,
          LoanAmount: res1?.Data?.LongTermResult?.Lrd_LoanAmount,
          InterestRate: res1?.Data?.LongTermResult?.LTLRate,
          AltlAmount: res1?.Data?.AdditionLongTermResult?.ALTLAmount,
          AdditionalLoanAmount:
            res1?.Data?.LongTermResult?.Lrd_AdditionalAmountByIntTeam,
          AltlRoi: res1?.Data?.AdditionLongTermResult?.Lrd_AltlRoi,
          AltlEligibleAmount: res1?.Data?.AdditionLongTermResult?.ALTLEligibleAmount,
          AdditionalGiveableLoanAmount: res1?.Data?.AdditionLongTermResult?.Lrd_AdditionalGiveableLoanAmount,
          GiveableLoanAmount: res1?.Data?.LongTermResult?.Lrd_GiveableLoanAmount,
        });
        // TermData.AltlAmount
        // TermData.AltlRoi

        // "ALTLAmount": 650000.0,
        // "ALTLEmi": 1291.67,
        // "ALTLEligibleAmount": 124000.0,
        // "ALTLRate": 12.1,
        // "ALTLDuration": 96,
        // "TotalALTLInterestPayable": 60641.01,
        // "TotalALTLPayment": 184641.01,

        setLongLoanEmi(res1?.Data?.LongTermResult?.LTLEmi);
        setLongTotalInterestPayable(
          res1?.Data?.LongTermResult?.TotalLTLInterestPayable
        );
        setLongTotalPayment(res1?.Data?.LongTermResult?.TotalLTLPayment);

        setALTLLongLoanEmi(res1?.Data?.AdditionLongTermResult?.ALTLEmi);
        setALTLLongTotalInterestPayable(
          res1?.Data?.AdditionLongTermResult?.TotalALTLInterestPayable
        );
        setALTLLongTotalPayment(
          res1?.Data?.AdditionLongTermResult?.TotalALTLPayment
        );
      } else {
        setTermData({
          ...TermData,
          LoanAmount: res?.Data?.Lrd_LoanAmount,
          AdditionalLoanAmount: res?.Data?.Lrd_AdditionalAmountByIntTeam,
          InterestRate: res?.Data?.Lrd_RateOfInterest,
          LoanTenure: res?.Data?.Lrd_InstallmentPeriod,
        });

        setLoanEmi(`${res?.Data?.LoanEmi}`);
        setTotalInterestPayable(`${res?.Data?.TotalInterestPayable}`);
        setTotalPayment(`${res?.Data?.TotalPayment}`);
      }

      hideLoader();
    } else {
      // notify(ToastType.Error, "Data not found");
    
      hideLoader();
    }
  };

  const onSubmit = async () => {
    showLoader();
    setFormErrors({});

    let param = {
      StatusId:
        confirmValue == "NO"
          ? LoanStatus.LoanModule_LoanApplicationCancelledByMember
          : loanType == LoanTypeEnum.SHORTTERM
            ? LoanStatus.LoanModule_LoanCommitteeApprovalPending
            : LoanStatus.LoanModule_LoanAgreementPending,
      LoanRequestId: loanParameters?.["LoanId"],
      UserIdApproval: context?.Id,
      MemberId: context?.MemberId,
      LoanEMI: loanType == LoanTypeEnum.SHORTTERM ? loanEmi : longLoanEmi,
      ALLoanEMI: aLTLLongLoanEmi,
    };

    let resp = await APICall(postLoanRequestStatusEMI, param);
    if (resp?.Status == ApiStatus.OK) {
      let loanMessage =
        confirmValue == "NO"
          ? "Loan Successfully rejected"
          : "Loan applied successfully.";
      notify(ToastType.Success, loanMessage);
      navigate("/LoanApprovalDashboard");
    } else {
      notify(ToastType.Error, resp?.Message || "Please try again later.");
    }
    hideLoader();
  };

  const handleCloseModal = (value: any = "NO") => {
    setConfirmValue(value);
    isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
  };

  const ModalDesign = () => {
    return (
      <>
        <div className={"ModalSize"}>
          <label
            className="d-block"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontFamily: "var(--bs-body-font-family)",
              fontSize: "var(--bs-body-font-size)",
            }}
          >
            {confirmValue == "YES"
              ? "Do you wish to apply for loan?"
              : "Are you sure want to reject your Loan?"}
          </label>

          <div className="row justify-content-end no-gutters">
            <div className="col-auto">
              <button
                onClick={() => {
                  setModalOpen(false);
                }}
                className="btn btn-secondary btn-sm mx-2"
              >
                Cancel
              </button>
            </div>
            <div className="col-auto">
              <button
                onClick={onSubmit}
                id={"saveBtn"}
                className="btn btn-secondary btn-sm"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const ShortTermComponent = () => {
    return (
      <div
        className="m-3 p-3 border border-danger"
        style={{ borderRadius: 20 }}
      >
        <div style={{ textAlign: "center" }}>
          <h5>
            Total amount approved for disbursement is{" "}
            {getFormattedCurrencyValueWithSymbol(
              TermData?.LoanAmount + TermData?.AdditionalLoanAmount
            )}
          </h5>
          {/* <p>
            <i className="fa fa-inr"></i>
            {"  "}
            {(TermData?.LoanAmount + TermData?.AdditionalLoanAmount)
              .toString()
              .replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,")}
          </p> */}
        </div>

        <div className="col-lg-12 col-md-12 pt-5">
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Loan Amount</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={TermData?.LoanAmount.toString().replace(
                  /(\d)(?=(\d{2})+\d(?!\d))/g,
                  "$1,"
                )}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            {/* <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group"></div>
              <label>Additional Loan Amount</label>
              <InputForm
                placeholder={""}
                value={TermData?.AdditionalLoanAmount.toString().replace(
                  /(\d)(?=(\d{2})+\d(?!\d))/g,
                  "$1,"
                )}
                isDisabled={true}
                maxLength={30}
              />
            </div> */}
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Interest rate</label>
              <InputForm
                placeholder={""}
                value={TermData?.InterestRate + " %"}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Loan Tenure</label>
              <InputForm
                placeholder={""}
                value={TermData?.LoanTenure + " Months"}
                isDisabled={true}
              />
            </div>
          </div>
          <div
            className="row m-3 border border-danger p-3 align-items-center"
            style={{ borderRadius: 20 }}
          >
            <div className="col px-md-5">
              <table className="table">
                <tr>
                  <td className="tableData">Monthly EMI: </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {loanEmi != null &&
                      loanEmi.toLocaleString("en-IN")}
                  </td>
                </tr>
                <tr>
                  <td className="tableData">Total Interest Payable: </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {totalInterestPayable != null &&
                      totalInterestPayable
                        .toLocaleString("en-IN")}
                  </td>
                </tr>
                <tr>
                  <td className="tableData">
                    Total Payment(Principal + Interest){" "}
                  </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {totalPayment != null &&
                      totalPayment
                        .toLocaleString("en-IN")}
                  </td>
                </tr>
              </table>
            </div>

            <div className="col px-md-5">
              <CanvasJSChart
                options={options}
              /* onRef = {ref => this.chart = ref} */
              />
            </div>
          </div>
          <div className="d-flex justify-content-center m-3">
            <div className="column">
              <h5>Do You Wish To Proceed ?</h5>

              <div className="d-flex justify-content-around m-3">
                <ButtonComponent
                  icon={""}
                  value={"NO"}
                  onClick={() => {
                    handleCloseModal("NO");
                  }}
                />
                <ButtonComponent
                  icon={""}
                  value={"YES"}
                  id="saveBtn"
                  className={"btn btn-primary"}
                  style={{ marginLeft: "10px" }}
                  onClick={() => {
                    handleCloseModal("YES");
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <BaseModal
          buttonText={""}
          open={isModalOpen}
          content={<ModalDesign />}
          onclose={handleCloseModal}
        />
      </div>
    );
  };

  const options = {
    title: {
      text: "Break-up of the Total Payment",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol(
          "{y}"
        )}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: TermData?.LoanAmount,
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: totalInterestPayable,
            color: "#ed892b",
            exploded: true,
          },
          // { label: "Total Interest", y: 15.2, color: "Green", exploded: true },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const ltiOption = {
    title: {
      text: "Long Term",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol(
          "{y}"
        )}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: TermData?.LoanAmount,
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: longTotalInterestPayable,
            color: "#ed892b",
            exploded: true,
          },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const altiOption = {
    title: {
      text: "Additional Long Term",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol(
          "{y}"
        )}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: TermData?.AltlEligibleAmount,
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: aLTLLongTotalInterestPayable,
            color: "#ed892b",
            exploded: true,
          },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const LongTermComponent = () => {
    return (
      <div className="mx-3 border border-danger" style={{ borderRadius: 20 }}>
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>{loanType === LoanTypeEnum.LONGTERM ? "Long" : "Short"} Term Loan Amount</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={TermData?.LoanAmount.toString().replace(
                  /(\d)(?=(\d{2})+\d(?!\d))/g,
                  "$1,"
                )}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group"></div>
              <label>Total Sanction Amount</label>
              {/* <label>Additional Loan Amount</label> */}
              <InputForm
                placeholder={""}
                value={TermData?.AdditionalLoanAmount.toString().replace(
                  /(\d)(?=(\d{2})+\d(?!\d))/g,
                  "$1,"
                )}
                isDisabled={true}
                maxLength={30}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Long Term ROI (%)</label>
              <InputForm
                placeholder={""}
                value={TermData?.InterestRate + " %"}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Loan Tenure</label>
              <InputForm
                placeholder={""}
                value={TermData?.LoanTenure + " Months"}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Additional Long Term Amount</label>
              <InputForm
                placeholder={""}
                value={TermData.AltlEligibleAmount.toLocaleString("en-IN")}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
              <label>Additional Long Term ROI (%)</label>
              <InputForm
                placeholder={""}
                value={TermData.AltlRoi + " %"}
                isDisabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group"></div>
              <label>Total Giveable Amount</label>
              <InputForm
                placeholder={""}
                value={(
                  ((TermData.GiveableLoanAmount || 0)) +
                  ((TermData.AdditionalGiveableLoanAmount || 0) || 0)
                ).toLocaleString("en-IN")}
                isDisabled={true}
              />
            </div>

            {/* <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group"></div>
              <label>Additional Long Term Giveable Amount</label>
              <InputForm
                placeholder={""}
                value={TermData.AdditionalGiveableLoanAmount?.toString()}
                isDisabled={true}
              />
            </div> */}
          </div>
          <div
            className="row m-3 border border-danger p-3"
            style={{ borderRadius: 20 }}
          >
            <div className="col px-md-5">
              <div className="row">
                <table className="table">
                  <tr>
                    <td className="tableData">Monthly EMI: </td>
                    <td className="tableData">Total Interest Payable</td>
                    <td className="tableData">
                      Total Payment (Principal + Interest)
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {longLoanEmi                    
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {longTotalInterestPayable
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {longTotalPayment
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                </table>
              </div>
              <CanvasJSChart
                options={ltiOption}
              /* onRef = {ref => this.chart = re f} */
              />
            </div>

            <div className="col px-md-5">
              <div className="row">
                <table className="table">
                  <tr>
                    <td className="tableData">Monthly EMI: </td>
                    <td className="tableData">Total Interest Payable</td>
                    <td className="tableData">
                      Total Payment (Principal + Interest)
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {aLTLLongLoanEmi
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {aLTLLongTotalInterestPayable
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {aLTLLongTotalPayment
                  .toLocaleString("en-IN")}
                    </td>
                  </tr>
                </table>
              </div>
              <CanvasJSChart
                options={altiOption}
              /* onRef = {ref => this.chart = ref} */
              />
            </div>
          </div>
          <div className="d-flex justify-content-center m-3">
            <div className="column">
              <h5>Do You Wish To Proceed ?</h5>

              <div className="d-flex justify-content-around m-3">
                <ButtonComponent
                  icon={""}
                  value={"NO"}
                  onClick={() => {
                    handleCloseModal("NO");
                  }}
                />
                <ButtonComponent
                  icon={""}
                  value={"YES"}
                  id="saveBtn"
                  className={"btn btn-primary"}
                  style={{ marginLeft: "10px" }}
                  onClick={() => {
                    handleCloseModal("YES");
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <BaseModal
          buttonText={""}
          open={isModalOpen}
          content={<ModalDesign />}
          onclose={handleCloseModal}
        />
      </div>
    );
  };

  return (
    <div>
      {loanType == LoanTypeEnum.SHORTTERM ? (
        <ShortTermComponent />
      ) : (
        <LongTermComponent />
      )}
    </div>
  );
};

export default LoanAmountDisbursement;
